import React from 'react'
import { SVGIconProps } from '../types'
const SvgFiberSmartRecord = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M24 24H0V0h24z" />
    <circle cx={9} cy={12} r={8} />
    <path d="M17 4.26v2.09a5.99 5.99 0 0 1 0 11.3v2.09c3.45-.89 6-4.01 6-7.74s-2.55-6.85-6-7.74" />
  </svg>
)
export default SvgFiberSmartRecord
